module.exports = __webpack_public_path__ + "img/main-bg.3aabf220.svg";